import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Box from '@mui/material/Box';
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

export const Banner = ({ text, icon, error, children }) => {
  return (
   text && <Box

      sx={(theme) => ({
        minHeight: '50px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexFlow: 'row nowrap',
        bgcolor:
          theme.palette.mode === 'dark'
            ? error
              ? alpha(theme.palette.error.main, 0.1)
              : alpha(theme.palette.primary.main, 0.1)
            : error
            ? theme.palette.error.light
            : theme.palette.primary.light,
        border: `1px solid ${error ? theme.palette.error.main : theme.palette.primary.main}`,
        borderRadius: 3,
        pl: 2,
        pr: 2
      })}
    >
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        {icon && (
          <FontAwesomeIcon
            icon={icon}
            style={{
              marginLeft: '10px',
              marginRight: '10px',
              width: '18px',
              verticalAlign: 'middle',
            }}
          />
        )}
        {text && (
          <Typography
            component="span"
            sx={{
              display: 'inline-block',
              verticalAlign: 'middle',
              lineHeight: 1.5,
            }}
          >
            {text}
          </Typography>
        )}
      </Box>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>{children}</Box>
    </Box>
  );
};
